// @ts-nocheck
import React, { useEffect, useState, useCallback, useRef } from "react";
import { Route, Link, Routes, useLocation, useNavigate } from 'react-router-dom';
import {
    AppstoreOutlined, MailOutlined, SettingOutlined, MenuUnfoldOutlined, MenuFoldOutlined, ToolOutlined, DeleteOutlined, DragOutlined,
    FontSizeOutlined,
    BarcodeOutlined,
    BorderOutlined,
    LineOutlined,
    QrcodeOutlined,
    MinusCircleOutlined,
    DownloadOutlined,
    PlusOutlined,
    ImportOutlined,
    PlayCircleOutlined,
    EditOutlined

} from '@ant-design/icons';
import { List, Alert, Flex, Collapse, Button, Steps, Menu, Layout, Result, FloatButton, ConfigProvider, Affix, Tabs, Space, Table, Tag, InputNumber, Input, ColorPicker, Tree, Col, Row, Slider, QRCode, Divider, Modal, Form, App, Select, Typography, Switch, Progress } from 'antd';
import * as XLSX from 'xlsx';
import pako from 'pako';
import {
    appendToList,
    clearList,
    getListClone,
    getListSize,
    initMemoryLists,
    registerNewList,
    removeList,
    syncResultListFromMemory,
} from "./db/memoryListStore";

import CardList from "./components/CardList";
import CardExec from "./components/CardExec";
import NodesWorkflow from "./components/NodesWorkflow";
import { convertNodesToExecutionSteps } from "./utils/convertNodesToSteps";
import { LOTTERY_MODALITIES } from "../../constants/lotteryModalidades";
import {
    buildDefaultParameterValues,
    getNodeTypeOption,
    getNodeTypeParameterDefinitions,
    getNodeTypeStepLinks,
    NODE_TYPE_OPTIONS,
    sanitizeParameterValues,
    validateNodeEditRequiredFields,
} from "../../constants/nodeTypeParameters";
import "./styles/strategy.css";

const ExcelJS = require("exceljs");

const DEFAULT_MODALITY = 'mega_sena';

const normalizeModality = (value) => {
    if (value && LOTTERY_MODALITIES.some((item) => item.value === value)) {
        return value;
    }
    return DEFAULT_MODALITY;
};

let tasks_list = [];
let result_list = [];
let tasks_stated = [];
let lista_gerada = [];
let list_id = null;
let plan_config = null;

const DEFAULT_LISTS = [
    {
        id: 0,
        type: 1,
        name: "Histórico",
        data: [],
        qtd: 0,
        excludeAfterUse: false,
    },
    {
        id: 1,
        type: 2,
        name: "Resultado final",
        data: [],
        qtd: 0,
        excludeAfterUse: false,
    },
];

const NODE_TYPE_SELECT_OPTIONS = NODE_TYPE_OPTIONS.map(({ value, label }) => ({ value, label }));

const FILTER_OPTIONS = [
    { value: 'qtdSequencias', label: 'Quantidade total de sequências (Mesmo não sendo continua)', parameters: ['min', 'max'] },
    { value: 'qtdSequenciaDiretaMax', label: 'Quantidade de sequências diretas (Continua)', parameters: ['min', 'max'] },
    { value: 'qtdNumPares', label: 'Quantidade de números pares', parameters: ['min', 'max'] },
    { value: 'qtdFibonacci', label: 'Quantidade de números de Fibonacci', parameters: ['min', 'max'] },
    { value: 'qtdNumPrimos', label: 'Quantidade de números primos', parameters: ['min', 'max'] },
    { value: 'qtdLinhas', label: 'Quantidade de linhas no volante', parameters: ['min', 'max', 'totNum'] },
    { value: 'qtdMaxLinha', label: 'Quantidade máxima de números em uma linha', parameters: ['min', 'max', 'totNum'] },
    { value: 'qtdColunas', label: 'Quantidade de colunas no volante', parameters: ['min', 'max'] },
    { value: 'qtdMaxColuna', label: 'Quantidade máxima de números em uma coluna', parameters: ['min', 'max'] },
    { value: 'distPrimUlt', label: 'Distância entre o primeiro e o último número', parameters: ['min', 'max'] },
    { value: 'menorNum', label: 'Menor número', parameters: ['min', 'max'] },
    { value: 'maiorNum', label: 'Maior número', parameters: ['min', 'max'] },
    { value: 'qtdQuadEm4Quad', label: 'Quantidade de quadrantes em 4 quadrantes', parameters: ['min', 'max', 'totNum'] },
    { value: 'qtdMaxQuadEm4Quad', label: 'Quantidade máxima de números por quadrante em 4 quadrantes', parameters: ['min', 'max', 'totNum'] },
    { value: 'qtdRepUltimo', label: 'Quantidade de repetições do último sorteio', parameters: ['min', 'max'] },
    { value: 'qtdRepAnteriores', label: 'Quantidade de repetições dos sorteios anteriores', parameters: ['min', 'max', 'qtd_jogos'] },
    { value: 'qtdAcertHistMax', label: 'Quantidade máxima de acertos com base no histórico', parameters: ['min', 'max'] },
];

const FILTER_PARAMETER_LABELS = {
    min: 'Mínimo',
    max: 'Máximo',
    totNum: 'Total de números',
    qtd_jogos: 'Quantidade de jogos',
};

const getFilterDefinition = (name) => FILTER_OPTIONS.find((item) => item.value === name);

const getFilterLabel = (name) => getFilterDefinition(name)?.label ?? name ?? '(sem nome)';

const LIST_ACTION_BUTTON_STYLE = {
    edit: { border: '1px solid #d9d9d9' },
    delete: { border: '1px solid #ff4d4f' },
};

const buildDefaultFilterParameters = (name) => {
    const definition = getFilterDefinition(name);
    if (!definition) {
        return {};
    }

    return definition.parameters.reduce((acc, key) => {
        acc[key] = 0;
        return acc;
    }, {});
};

const sanitizeFilterParameters = (name, parameters = {}) => {
    const definition = getFilterDefinition(name);
    if (!definition) {
        return { ...parameters };
    }

    return definition.parameters.reduce((acc, key) => {
        if (parameters[key] !== undefined && parameters[key] !== null) {
            acc[key] = parameters[key];
        }
        return acc;
    }, {});
};

const formatFilterDescription = (filter) => {
    const definition = getFilterDefinition(filter.name);
    if (!definition) {
        return Object.entries(filter.parameters ?? {})
            .map(([key, value]) => `${key}: ${value}`)
            .join(' | ');
    }

    return definition.parameters
        .map((key) => `${FILTER_PARAMETER_LABELS[key] || key}: ${filter.parameters?.[key] ?? '-'}`)
        .join(' | ');
};

const parseNodeForEdit = (node) => {
    let editFilters = [];
    const nodeType = node?.type ?? 1;

    if (Array.isArray(node?.filters)) {
        editFilters = node.filters.map((filter) => ({
            name: filter.name ?? '',
            parameters: sanitizeFilterParameters(filter.name, filter.parameters ?? {}),
        }));
    }

    const params = node?.parameters;
    let rawParameters = {};

    if (params && typeof params === 'object' && !Array.isArray(params)) {
        rawParameters = { ...params };

        if (Array.isArray(params.filters) && editFilters.length === 0) {
            editFilters = params.filters.map((filter) => ({
                name: filter.name ?? '',
                parameters: sanitizeFilterParameters(filter.name, filter.parameters ?? {}),
            }));
        }
    }

    delete rawParameters.filters;

    const typeOption = getNodeTypeOption(nodeType);

    return {
        editParameterValues: typeOption.params
            ? sanitizeParameterValues(nodeType, rawParameters)
            : {},
        editFilters: typeOption.filter ? editFilters : [],
        editFrom: typeOption.from && Array.isArray(node?.from) ? [...node.from] : [],
        editFromListId: node?.fromListId ?? null,
        editToListId: node?.toListId ?? null,
    };
};

const buildNodeParameters = (editType, editFrom, editParameterValues, editFilters) => {
    const typeOption = getNodeTypeOption(editType);
    const parameters = {};

    if (typeOption.params) {
        getNodeTypeParameterDefinitions(editType).forEach((definition) => {
            const value = editParameterValues?.[definition.key];
            if (value !== undefined && value !== null && value !== '') {
                parameters[definition.key] = value;
            }
        });
    }

    return {
        parameters,
        filters: typeOption.filter
            ? editFilters
                .filter((filter) => filter.name?.trim())
                .map((filter) => ({
                    name: filter.name.trim(),
                    parameters: sanitizeFilterParameters(filter.name.trim(), filter.parameters ?? {}),
                }))
            : [],
        from: typeOption.from ? editFrom : [],
    };
};

const parsePlanFile = (data) => {
    if (!data || typeof data !== "object" || !Array.isArray(data.lists)) {
        throw new Error("Formato de arquivo inválido");
    }

    const extraLists = data.lists
        .filter((item) => item && item.id !== 0 && item.id !== 1)
        .map((item) => ({
            id: item.id,
            type: item.type ?? 3,
            name: item.name ?? `Lista ${item.id}`,
            data: item.data ?? [],
            qtd: item.qtd ?? 0,
            excludeAfterUse: item.excludeAfterUse ?? false,
        }));

    const steps = Array.isArray(data.steps)
        ? data.steps.map((step, index) => ({
            id: step.id ?? index + 1,
            type: step.type,
            parameters: step.parameters ?? {},
            dependencies: step.dependencies ?? [],
            percent: step.percent ?? 0,
            running: step.running ?? false,
            status: step.status ?? false,
        }))
        : [];

    const nodes = Array.isArray(data.nodes)
        ? data.nodes.map((node, index) => ({
            id: node.id ?? index,
            type: node.type ?? 1,
            title: node.title ?? `Etapa ${node.id ?? index}`,
            parameters: node.parameters ?? {},
            filters: node.filters ?? node.parameters?.filters ?? [],
            from: node.from ?? [],
            fromListId: node.fromListId ?? null,
            toListId: node.toListId ?? null,
        }))
        : [];

    return {
        layoutVersion: data.layout_version ?? 1,
        title: data.title || null,
        modality: normalizeModality(data.modality),
        lists: [...DEFAULT_LISTS, ...extraLists],
        steps,
        nodes,
    };
};

const buildPlanExport = ({ title, modality, lists, nodes, planConfig }) => {
    const exportLists = lists
        .filter((item) => item && item.id !== 0 && item.id !== 1)
        .map(({ id, type, name, excludeAfterUse }) => ({
            id,
            type,
            name,
            data: [],
            qtd: 0,
            excludeAfterUse: excludeAfterUse ?? false,
        }));

    const exportNodes = nodes.map(({ id, type, title: nodeTitle, parameters, filters, from, fromListId, toListId }) => ({
        id,
        type,
        title: nodeTitle,
        parameters: parameters ?? {},
        filters: filters ?? [],
        from: from ?? [],
        fromListId: fromListId ?? null,
        toListId: toListId ?? null,
    }));

    return {
        layout_version: planConfig?.layoutVersion ?? 1,
        title: title === "?" ? null : title,
        modality: normalizeModality(modality),
        lists: exportLists,
        nodes: exportNodes,
    };
};

const downloadJsonFile = (payload, filename) => {
    const blob = new Blob([JSON.stringify(payload, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
    URL.revokeObjectURL(url);
};

const TLSGerarCombinacoesContent = () => {

    const { modal, message } = App.useApp();
    const [tasks, setTasks] = useState<any[]>([]);
    const [lists, setLists] = useState<any[]>([]);
    const [nodes, setNodes] = useState<any[]>([]);
    const [valid, setValid] = useState<any[]>([]);
    const [running, setRunning] = useState(false);
    const [finish, setFinish] = useState(false);
    const [log, setLog] = useState<any[]>([]);
    const [current, setCurrent] = useState(0);
    const [title, setTitle] = useState("?");
    const [modality, setModality] = useState(DEFAULT_MODALITY);
    const [planFileAlert, setPlanFileAlert] = useState(null);
    const [listEditModal, setListEditModal] = useState({
        open: false,
        originalId: null,
        editId: null,
        editName: '',
        editExcludeAfterUse: false,
        error: '',
    });
    const [nodeEditModal, setNodeEditModal] = useState({
        open: false,
        originalId: null,
        editId: null,
        editTitle: '',
        editType: 1,
        editFrom: [],
        editFromListId: null,
        editToListId: null,
        editParameterValues: {},
        editFilters: [],
        error: '',
        fieldErrors: {},
    });
    const [filterItemModal, setFilterItemModal] = useState({
        open: false,
        editIndex: null,
        name: '',
        parameters: {},
        error: '',
    });

    const inputXlsx = useRef(null);
    const listIdRef = useRef(null);
    const inputJSONPlan = useRef(null);

    useEffect(() => {

        result_list = [...DEFAULT_LISTS];

        initMemoryLists(result_list);
        setLists(syncResultListFromMemory(result_list));

    }, []);

    const applyListAppend = useCallback((listAppend) => {
        if (!listAppend?.listId || !Array.isArray(listAppend.items)) {
            return;
        }

        appendToList(listAppend.listId, listAppend.items);
        const size = getListSize(listAppend.listId);

        setLists((prevLists) =>
            prevLists.map((item) =>
                item.id === listAppend.listId ? { ...item, qtd: size } : item
            )
        );
        result_list = result_list.map((item) =>
            item.id === listAppend.listId ? { ...item, qtd: size } : item
        );
    }, []);

    const ExcelToJSON = useCallback((file, targetListId) => {

        if (!file || targetListId === null || targetListId === undefined) {
            return;
        }

        const reader = new FileReader();
        reader.onload = function (event) {
            try {
                const data = event.target.result;
                const workbook = XLSX.read(data, {
                    type: 'binary'
                });

                let totalRows = 0;

                workbook.SheetNames.forEach(function (sheetName) {
                    const sheet = workbook.Sheets[sheetName];
                    if (!sheet?.['!ref']) {
                        return;
                    }

                    const range = XLSX.utils.decode_range(sheet['!ref']);
                    let idx = 0;

                    clearList(targetListId);

                    for (let rowNum = range.s.r; rowNum <= range.e.r; rowNum++) {
                        const comb = [];
                        for (let colNum = range.s.c; colNum <= range.e.c; colNum++) {
                            const secondCell = sheet[XLSX.utils.encode_cell({ r: rowNum, c: colNum })];
                            if (secondCell != undefined && secondCell.v != "") {
                                comb.push(secondCell.v);
                            }
                        }

                        lista_gerada.push(comb);
                        idx++;
                        totalRows++;

                        if (idx == 100000) {
                            idx = 0;
                            appendToList(targetListId, lista_gerada);
                            setLists(l => l.map(s =>
                                s.id === targetListId ? { ...s, qtd: getListSize(targetListId) } : s
                            ));
                            lista_gerada = [];
                        }
                    }

                    appendToList(targetListId, lista_gerada);
                    result_list = result_list.map((item) =>
                        item.id === targetListId
                            ? { ...item, qtd: getListSize(targetListId) }
                            : item
                    );
                    setLists(l => l.map(s =>
                        s.id === targetListId ? { ...s, qtd: getListSize(targetListId) } : s
                    ));
                    lista_gerada = [];
                });

                message.success('Arquivo carregado com sucesso!');
            } catch (err) {
                console.log(err);
                message.error('Erro ao carregar o arquivo.');
            }
        };

        reader.onerror = function (ex) {
            console.log(ex);
            message.error('Erro ao ler o arquivo.');
        };

        reader.readAsBinaryString(file);

    }, [message]);

    const handleFileUpload = useCallback((e) => {

        const input = e.target;
        const file = input.files?.[0];
        const targetListId = listIdRef.current;

        input.value = '';

        if (!file) {
            return;
        }

        if (targetListId === null || targetListId === undefined) {
            message.warning('Selecione uma lista para carregar o arquivo.');
            return;
        }

        ExcelToJSON(file, targetListId);

    }, [ExcelToJSON, message]);

    const handlePlanFileUpload = useCallback((e) => {

        const file = e.target.files?.[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = function (event) {
            try {
                const data = JSON.parse(event.target.result);
                const plan = parsePlanFile(data);

                if (plan.title) {
                    setTitle(plan.title);
                } else {
                    setTitle("?");
                }

                setModality(plan.modality);

                result_list = plan.lists;
                plan_config = {
                    layoutVersion: plan.layoutVersion,
                    modality: plan.modality,
                    steps: plan.steps,
                    nodes: plan.nodes,
                };

                initMemoryLists(plan.lists);
                result_list = syncResultListFromMemory(plan.lists);
                setLists(result_list);
                setNodes(plan.nodes);
                syncPlanNodes(plan.nodes);
                setValid([]);
                setTasks([]);

                //setPlanFileAlert({ type: 'success', message: 'Arquivo de configurações carregado com sucesso!' });
                message.success('Arquivo de configurações carregado com sucesso!');
            } catch {
                //setPlanFileAlert({ type: 'error', message: 'Formato de arquivo inválido' });
                message.error('Formato de arquivo inválido');
            }
        };

        reader.onerror = function () {
            setPlanFileAlert({ type: 'error', message: 'Formato de arquivo inválido' });
        };

        reader.readAsText(file);

    }, []);

    const handleExportPlan = () => {
        const payload = buildPlanExport({
            title,
            modality,
            lists,
            nodes,
            planConfig: plan_config,
        });

        const safeTitle = (title && title !== "?" ? title : "estrategia")
            .replace(/[^\w\s-áàâãéèêíìîóòôõúùûçÁÀÂÃÉÈÊÍÌÎÓÒÔÕÚÙÛÇ-]/g, "")
            .trim()
            .replace(/\s+/g, "_") || "estrategia";

        downloadJsonFile(payload, `${safeTitle}.json`);
    };

    const syncPlanNodes = (updatedNodes) => {
        plan_config = plan_config
            ? { ...plan_config, nodes: updatedNodes }
            : { layoutVersion: 1, modality, steps: [], nodes: updatedNodes };
    };

    const handleModalityChange = (value) => {
        const nextModality = normalizeModality(value);
        setModality(nextModality);
        plan_config = plan_config
            ? { ...plan_config, modality: nextModality }
            : { layoutVersion: 1, modality: nextModality, steps: [], nodes: [] };
    };

    const handleTitleChange = (value) => {
        const nextTitle = value.trim();
        setTitle(nextTitle || "?");
    };

    const handleAddList = () => {
        if (running) return;

        const nextId = lists.length ? Math.max(...lists.map((item) => item.id)) + 1 : 2;
        const newList = {
            id: nextId,
            type: 3,
            name: `Lista ${nextId}`,
            data: [],
            qtd: 0,
            excludeAfterUse: false,
        };
        const updatedLists = [...lists, newList];

        registerNewList(nextId);
        result_list = updatedLists;
        setLists(updatedLists);
    };

    const handleAddNode = () => {
        if (running) return;

        setNodes((prevNodes) => {
            const nextId = prevNodes.length ? Math.max(...prevNodes.map((node) => node.id)) + 1 : 0;
            const updatedNodes = [
                ...prevNodes,
                {
                    id: nextId,
                    type: 1,
                    title: `Etapa ${nextId}`,
                    parameters: buildDefaultParameterValues(1),
                    filters: [],
                    from: [],
                },
            ];
            syncPlanNodes(updatedNodes);
            return updatedNodes;
        });
    };

    const handleOpenNodeSettings = (node) => {
        const { editParameterValues, editFilters, editFrom, editFromListId, editToListId } = parseNodeForEdit(node);

        setNodeEditModal({
            open: true,
            originalId: node.id,
            editId: node.id,
            editTitle: node.title,
            editType: node.type ?? 1,
            editFrom,
            editFromListId,
            editToListId,
            editParameterValues,
            editFilters,
            error: '',
            fieldErrors: {},
        });
    };

    const handleCloseNodeEdit = () => {
        setFilterItemModal({
            open: false,
            editIndex: null,
            name: '',
            parameters: {},
            error: '',
        });
        setNodeEditModal({
            open: false,
            originalId: null,
            editId: null,
            editTitle: '',
            editType: 1,
            editFrom: [],
            editFromListId: null,
            editToListId: null,
            editParameterValues: {},
            editFilters: [],
            error: '',
            fieldErrors: {},
        });
    };

    const handleNodeTypeChange = (value) => {
        const nextType = value ?? 1;
        const typeOption = getNodeTypeOption(nextType);
        const stepLinks = getNodeTypeStepLinks(nextType);

        setNodeEditModal((prev) => ({
            ...prev,
            editType: nextType,
            editFrom: typeOption.from ? prev.editFrom : [],
            editFromListId: stepLinks.usesFromList ? prev.editFromListId : null,
            editToListId: stepLinks.usesToList ? prev.editToListId : null,
            editFilters: typeOption.filter ? prev.editFilters : [],
            editParameterValues: typeOption.params
                ? buildDefaultParameterValues(nextType, prev.editParameterValues)
                : {},
            error: '',
            fieldErrors: {},
        }));
    };

    const handleParameterValueChange = (key, value, inputType) => {
        setNodeEditModal((prev) => {
            const nextFieldErrors = { ...prev.fieldErrors };

            if (nextFieldErrors.parameters?.[key]) {
                const nextParameters = { ...nextFieldErrors.parameters };
                delete nextParameters[key];
                nextFieldErrors.parameters = Object.keys(nextParameters).length
                    ? nextParameters
                    : undefined;
            }

            if (inputType === 'array') {
                try {
                    return {
                        ...prev,
                        editParameterValues: {
                            ...prev.editParameterValues,
                            [key]: JSON.parse(value),
                        },
                        error: '',
                        fieldErrors: nextFieldErrors,
                    };
                } catch {
                    return prev;
                }
            }

            return {
                ...prev,
                editParameterValues: {
                    ...prev.editParameterValues,
                    [key]: value,
                },
                error: '',
                fieldErrors: nextFieldErrors,
            };
        });
    };

    const handleOpenAddFilter = () => {
        setFilterItemModal({
            open: true,
            editIndex: null,
            name: '',
            parameters: {},
            error: '',
        });
    };

    const handleOpenEditFilter = (index) => {
        const item = nodeEditModal.editFilters[index];
        setFilterItemModal({
            open: true,
            editIndex: index,
            name: item.name ?? '',
            parameters: sanitizeFilterParameters(item.name, item.parameters ?? {}),
            error: '',
        });
    };

    const handleCloseFilterItemModal = () => {
        setFilterItemModal({
            open: false,
            editIndex: null,
            name: '',
            parameters: {},
            error: '',
        });
    };

    const handleFilterNameChange = (name) => {
        setFilterItemModal((prev) => {
            const defaults = buildDefaultFilterParameters(name);
            const definition = getFilterDefinition(name);
            const nextParameters = { ...defaults };

            if (definition) {
                definition.parameters.forEach((key) => {
                    if (prev.parameters[key] !== undefined && prev.parameters[key] !== null) {
                        nextParameters[key] = prev.parameters[key];
                    }
                });
            }

            return {
                ...prev,
                name,
                parameters: nextParameters,
                error: '',
            };
        });
    };

    const handleFilterParameterChange = (key, value) => {
        setFilterItemModal((prev) => ({
            ...prev,
            parameters: {
                ...prev.parameters,
                [key]: value,
            },
            error: '',
        }));
    };

    const handleSaveFilterItem = () => {
        const name = filterItemModal.name?.trim();
        const definition = getFilterDefinition(name);

        if (!name || !definition) {
            setFilterItemModal((prev) => ({ ...prev, error: 'Selecione um filtro válido' }));
            return;
        }

        const parameters = {};
        for (const key of definition.parameters) {
            const value = filterItemModal.parameters[key];
            if (value === undefined || value === null || value === '') {
                setFilterItemModal((prev) => ({
                    ...prev,
                    error: `Informe ${FILTER_PARAMETER_LABELS[key] || key}`,
                }));
                return;
            }
            parameters[key] = Number(value);
        }

        setNodeEditModal((prev) => {
            const updatedFilters = [...prev.editFilters];
            const item = {
                name,
                parameters,
            };

            if (filterItemModal.editIndex === null) {
                updatedFilters.push(item);
            } else {
                updatedFilters[filterItemModal.editIndex] = item;
            }

            return { ...prev, editFilters: updatedFilters };
        });

        handleCloseFilterItemModal();
    };

    const handleRemoveNodeFilter = (index) => {
        setNodeEditModal((prev) => ({
            ...prev,
            editFilters: prev.editFilters.filter((_, itemIndex) => itemIndex !== index),
        }));
    };

    const handleSaveNodeEdit = () => {
        const newId = Number(nodeEditModal.editId);
        const newTitle = nodeEditModal.editTitle?.trim();
        const originalId = nodeEditModal.originalId;

        if (newTitle === '') {
            setNodeEditModal((prev) => ({ ...prev, error: 'Informe um título válido', fieldErrors: {} }));
            return;
        }

        if (Number.isNaN(newId) || !Number.isInteger(newId)) {
            setNodeEditModal((prev) => ({ ...prev, error: 'Informe um ID numérico válido', fieldErrors: {} }));
            return;
        }

        if (getNodeTypeOption(nodeEditModal.editType).from && nodeEditModal.editFrom.includes(newId)) {
            setNodeEditModal((prev) => ({ ...prev, error: 'A etapa não pode depender dela mesma', fieldErrors: {} }));
            return;
        }

        const idExists = nodes.some((item) => item.id === newId && item.id !== originalId);
        if (idExists) {
            setNodeEditModal((prev) => ({ ...prev, error: 'Este ID já está em uso nas etapas', fieldErrors: {} }));
            return;
        }

        const requiredValidation = validateNodeEditRequiredFields(
            nodeEditModal.editType,
            nodeEditModal.editFrom,
            nodeEditModal.editParameterValues,
            nodeEditModal.editFromListId,
            nodeEditModal.editToListId
        );

        if (!requiredValidation.valid) {
            setNodeEditModal((prev) => ({
                ...prev,
                error: requiredValidation.message,
                fieldErrors: requiredValidation.fields,
            }));
            return;
        }

        setNodes((prevNodes) => {
            const { parameters, filters, from } = buildNodeParameters(
                nodeEditModal.editType,
                nodeEditModal.editFrom,
                nodeEditModal.editParameterValues,
                nodeEditModal.editFilters
            );

            const updatedNodes = prevNodes.map((node) => {
                if (node.id === originalId) {
                    return {
                        ...node,
                        id: newId,
                        title: newTitle,
                        type: nodeEditModal.editType,
                        from,
                        fromListId: nodeEditModal.editFromListId,
                        toListId: nodeEditModal.editToListId,
                        parameters,
                        filters,
                    };
                }

                return {
                    ...node,
                    from: Array.isArray(node.from)
                        ? node.from.map((fromId) => (fromId === originalId ? newId : fromId))
                        : [],
                };
            });

            syncPlanNodes(updatedNodes);
            return updatedNodes;
        });

        handleCloseNodeEdit();
    };

    const handleDeleteNodeEdit = () => {
        const originalId = nodeEditModal.originalId;
        const nodeTitle = nodeEditModal.editTitle;

        modal.confirm({
            title: 'Excluir etapa',
            content: `Deseja excluir a etapa "${nodeTitle}"? Esta ação não pode ser desfeita.`,
            okText: 'Excluir',
            okType: 'danger',
            cancelText: 'Cancelar',
            onOk: () => {
                setNodes((prevNodes) => {
                    const updatedNodes = prevNodes
                        .filter((node) => node.id !== originalId)
                        .map((node) => ({
                            ...node,
                            from: Array.isArray(node.from)
                                ? node.from.filter((fromId) => fromId !== originalId)
                                : [],
                        }));

                    syncPlanNodes(updatedNodes);
                    return updatedNodes;
                });

                handleCloseNodeEdit();
            },
        });
    };

    const handleOpenListSettings = (card) => {
        setListEditModal({
            open: true,
            originalId: card.id,
            editId: card.id,
            editName: card.name,
            editExcludeAfterUse: card.excludeAfterUse ?? false,
            error: '',
        });
    };

    const handleCloseListEdit = () => {
        setListEditModal({
            open: false,
            originalId: null,
            editId: null,
            editName: '',
            editExcludeAfterUse: false,
            error: '',
        });
    };

    const handleSaveListEdit = () => {
        const newId = Number(listEditModal.editId);
        const newName = listEditModal.editName?.trim();
        const originalId = listEditModal.originalId;

        if (newName === '') {
            setListEditModal((prev) => ({ ...prev, error: 'Informe um nome válido' }));
            return;
        }

        if (Number.isNaN(newId) || !Number.isInteger(newId)) {
            setListEditModal((prev) => ({ ...prev, error: 'Informe um ID numérico válido' }));
            return;
        }

        const idExists = lists.some((item) => item.id === newId && item.id !== originalId);
        if (idExists) {
            setListEditModal((prev) => ({ ...prev, error: 'Este ID já está em uso na lista' }));
            return;
        }

        setLists((prevLists) =>
            prevLists.map((item) =>
                item.id === originalId
                    ? {
                        ...item,
                        id: newId,
                        name: newName,
                        excludeAfterUse: listEditModal.editExcludeAfterUse,
                    }
                    : item
            )
        );

        result_list = result_list.map((item) =>
            item.id === originalId
                ? {
                    ...item,
                    id: newId,
                    name: newName,
                    excludeAfterUse: listEditModal.editExcludeAfterUse,
                }
                : item
        );

        if (list_id === originalId) {
            list_id = newId;
        }

        handleCloseListEdit();
    };

    const handleDeleteListEdit = () => {
        const originalId = listEditModal.originalId;
        const listName = listEditModal.editName;

        modal.confirm({
            title: 'Excluir lista',
            content: `Deseja excluir a lista "${listName}"? Esta ação não pode ser desfeita.`,
            okText: 'Excluir',
            okType: 'danger',
            cancelText: 'Cancelar',
            onOk: () => {
                removeList(originalId);

                setLists((prevLists) => prevLists.filter((item) => item.id !== originalId));
                result_list = result_list.filter((item) => item.id !== originalId);

                if (list_id === originalId) {
                    list_id = null;
                }

                handleCloseListEdit();
            },
        });
    };

    const exportExcelFile = async (list_id) => {

        const workbook = new ExcelJS.Workbook();
        workbook.creator = 'Geração de combinações';
        let idx_tab = 1;
        let qtd_max_tab = 1000000;
        let qtd_atua_tab = 0;

        let sheet = workbook.addWorksheet("JOGOS " + idx_tab);

        let result = getListClone(list_id);

        result.map((comb, index) => {

            sheet.getRow(index + 1).values = comb;
            qtd_atua_tab++;
            if (qtd_atua_tab == qtd_max_tab) {
                qtd_atua_tab = 0;
                idx_tab++;
                sheet = workbook.addWorksheet("JOGOS " + idx_tab);
            }
        });

        workbook.xlsx.writeBuffer().then(function (data) {
            const blob = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = window.URL.createObjectURL(blob);
            const anchor = document.createElement("a");
            anchor.href = url;
            anchor.download = "geracao_de_combinacoes.xlsx";
            anchor.click();
            window.URL.revokeObjectURL(url);
        });
    };

    function verificaTasks() {

        //Inicia o condutor
        const cnWebWorker = new Worker(new URL("./workers/conductorWorker.ts", import.meta.url), { type: "module" });
        cnWebWorker.addEventListener('message', (event) => {

            let { task, comando } = event.data;
            if (comando == "start") {

                if (!tasks_stated.includes(task.id)) {

                    tasks_stated.push(task.id);
                    logAdd('Execução', 'Início da task ' + task.id);

                    const exWebWorker = new Worker(new URL("./workers/executorWorker.ts", import.meta.url), { type: "module" });
                    exWebWorker.addEventListener('message', (event) => {

                        let { task, percent, qtd, result, listAppend } = event.data;

                        if (listAppend) {
                            applyListAppend(listAppend);
                        }

                        //Atualiza os status e percentuais
                        tasks_list.filter((x) => x.id === task.id).map((x) => {
                            x.percent = percent;
                            x.running = true;
                            x.status = percent == 100 ? true : false;
                            x.qtd = qtd;
                        });

                        setTasks(t => t.map(s =>
                            s.id === task.id ? { ...s, percent: percent, running: true, status: percent == 100 ? true : false } : s
                        ));

                        if (task.type !== 6 && task.type !== 9 && task.type !== 10 && task.type !== 11) {

                            setLists(l => l.map(s =>
                                s.id === task.parameters.to ? { ...s, qtd: qtd } : s
                            ));
                        }

                        if (percent >= 100) {

                            if (task.type === 6 || task.type === 9 || task.type === 10 || task.type === 11) {

                                let from_desc = task.parameters.from;
                                let to_desc = task.parameters.to;
                                for (let i = 0; i < result_list.length; i++) {
                                    if (result_list[i].id === task.parameters.from) {
                                        from_desc = result_list[i].name;
                                    }
                                    if (result_list[i].id === task.parameters.to) {
                                        to_desc = result_list[i].name;
                                    }
                                }
                                result.name = 'From: ' + from_desc + " -> To: " + to_desc + ((task.type === 6) ? " (Máximo)" : " (Minímo)");
                                //console.log(result);
                                setValid(prevItens => [...prevItens, result]);

                            } else {

                                // if (task.parameters.to !== undefined && result !== undefined) {
                                //     handleAddToList(task.parameters.to, result);
                                //     //console.log('Add =====>',result.length,'=== to =====>',task.parameters.to);
                                // }

                                if (task.parameters.from !== undefined && task.parameters.clear !== undefined && task.parameters.clear === true) {
                                    handleClearFromList(task.parameters.from);
                                }
                            }

                            //verificaTasks();
                            //setTimeout(verificaTasks, 0);
                            //console.log(task, result);
                            logAdd('Execução', 'Fim da task ' + task.id);
                            exWebWorker.terminate();
                        }

                    });

                    const typesNeedingBaseList = [3, 4, 5, 6, 7, 9, 10, 11];
                    const typesNeedingToList = [4, 5, 6, 9, 10, 11];

                    let base_list = [];
                    if (task.parameters?.from !== undefined && typesNeedingBaseList.includes(task.type)) {
                        base_list = getListClone(task.parameters.from);
                    }

                    const hist_list = getListClone(0);

                    let to_list = [];
                    if (task.parameters?.to !== undefined && typesNeedingToList.includes(task.type)) {
                        to_list = getListClone(task.parameters.to);
                    }

                    const initialTargetQtd = task.parameters?.to !== undefined
                        ? getListSize(task.parameters.to)
                        : 0;

                    exWebWorker.postMessage({ task, base_list, hist_list, to_list, initialTargetQtd });
                }
                setTimeout(verificaTasks, 3000);

            } else if (comando == "update") {

                setTimeout(verificaTasks, 3000);

            } else if (comando == "finish") {

                setRunning(false);
                setFinish(true);
            }
            cnWebWorker.terminate();
        });

        //console.log('tasks_list',tasks_list);
        cnWebWorker.postMessage({ tasks: tasks_list });
    }

    // const handleAddToList = (to, result) => {

    //     const result2 = base64ToGzip(result)

    //     for (let i = 0; i < result_list.length; i++) {
    //         if (result_list[i].id == to) {
    //             for (let j = 0; j < result2.length; j++) {
    //                 result_list[i].data.push(result2[j]);
    //             }
    //             //result_list[i].data.push(...result);
    //             //result_list[i].data.concat(result);
    //             //console.log(result_list);
    //             setLists(l => l.map(s =>
    //                 s.id === to ? { ...s, qtd: result_list[i].data.length } : s
    //             ));
    //         }
    //     }
    // }

    const handleClearFromList = (from) => {
        clearList(from);
        setLists(l => l.map(s =>
            s.id === from ? { ...s, qtd: getListSize(from) } : s
        ));
        result_list = result_list.map((item) =>
            item.id === from ? { ...item, qtd: getListSize(from) } : item
        );
    }

    const handleStart = () => {

        setLog([]);
        setCurrent(0);
        setRunning(() => { return true });
        setFinish(() => { return false });
        setValid([]);
        tasks_stated = [];

        const convertedTasks = nodes.length > 0
            ? convertNodesToExecutionSteps(nodes, modality).steps.map((step) => ({ ...step }))
            : undefined;

        const plWebWorker = new Worker(new URL("./workers/plannerWorker.ts", import.meta.url), { type: "module" });
        plWebWorker.addEventListener('message', (event) => {

            //Recebe as tasks
            tasks_list = event.data;
            setTasks(tasks_list);
            console.log(tasks_list);

            logAdd('Planejamento', convertedTasks?.length
                ? 'Etapas geradas a partir do workflow'
                : 'Fim do planejamento');

            //Inicia o condutor
            verificaTasks();

            //Finaliza o worker
            plWebWorker.terminate();
        });
        plWebWorker.postMessage({ comando: "start", tasks: convertedTasks });
        logAdd('Planejamento', convertedTasks?.length
            ? 'Início do planejamento (workflow)'
            : 'Início do planejamento');
    };

    function padTwoDigits(num) {
        return num.toString().padStart(2, "0");
    }

    function getDt() {

        let date = new Date();
        return (
            [
                padTwoDigits(date.getDate()),
                padTwoDigits(date.getMonth() + 1),
                date.getFullYear()
            ].join("/") +
            " " +
            [
                padTwoDigits(date.getHours()),
                padTwoDigits(date.getMinutes()),
                padTwoDigits(date.getSeconds()),
            ].join(":")
        );
    }

    const logAdd = (title, content) => {
        setLog(prevItens => [...prevItens, {
            title: title,
            description: getDt() + " - " + content,
        }]);
        setCurrent(prevState => prevState + 1);
    };

    const completedTasksCount = tasks.filter((task) => task.status === true).length;
    const runningTasksCount = tasks.filter((task) => task.running && !task.status).length;
    const overallExecutionPercent = tasks.length > 0
        ? Math.min(
            100,
            Math.round(
                tasks.reduce((sum, task) => sum + (task.status ? 100 : (task.percent ?? 0)), 0) / tasks.length
            )
        )
        : 0;
    const activeTask = tasks.find((task) => task.running && !task.status);

    const executionProgressBar = tasks.length > 0 && (running || finish) ? (
        <div style={{ marginBottom: 16 }}>
            <Flex justify="space-between" align="center" style={{ marginBottom: 8 }}>
                <Typography.Text>
                    {completedTasksCount} de {tasks.length} etapas concluídas
                    {runningTasksCount > 0 ? ` — ${runningTasksCount} em execução` : ''}
                </Typography.Text>
                <Typography.Text strong>{overallExecutionPercent}%</Typography.Text>
            </Flex>
            <Progress
                percent={overallExecutionPercent}
                status={finish ? 'success' : running ? 'active' : 'normal'}
                strokeLinecap="round"
            />
            {activeTask && (
                <Typography.Text type="secondary" style={{ display: 'block', marginTop: 8 }}>
                    Etapa {activeTask.id}: {Math.round(activeTask.percent ?? 0)}%
                </Typography.Text>
            )}
        </div>
    ) : null;

    const items = [
        {
            key: '1',
            label: 'Listas',
            children: <>
                <Flex className="workflow-toolbar" justify="flex-start">
                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        disabled={running}
                        onClick={handleAddList}
                    >
                        Adicionar
                    </Button>
                </Flex>
                <Flex wrap gap="small" justify="center">
                    <input type="file" ref={inputXlsx} onChange={handleFileUpload} style={{ display: 'none' }} />
                    {
                        lists.map((card) =>
                        (<div key={card.id}
                            onClick={() => {
                                if (running == false && finish == false) {
                                    list_id = card.id;
                                    listIdRef.current = card.id;
                                    if (inputXlsx.current) {
                                        inputXlsx.current.value = '';
                                    }
                                    inputXlsx.current.click();
                                } else if (running == false && finish == true) {
                                    exportExcelFile(card.id)
                                }
                            }}
                        >
                            <CardList card={card} running={running} onSettingsClick={handleOpenListSettings} />
                        </div>)
                        )}
                </Flex>
            </>,
        },
        {
            key: '2',
            label: 'Etapas ( ' + nodes.length + ' )',
            children: <>
                <Flex className="workflow-toolbar" justify="flex-start">
                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        disabled={running}
                        onClick={handleAddNode}
                    >
                        Adicionar
                    </Button>
                </Flex>
                <NodesWorkflow
                    nodes={nodes}
                    running={running}
                    onSettingsClick={handleOpenNodeSettings}
                />
            </>,
        },
        {
            key: '3',
            label: 'Execução ( ' + completedTasksCount + ' / ' + tasks.length + ' )',
            children: <>
                <Flex wrap gap="small" justify="center">
                {
                    tasks.length > 0 ?
                        tasks.map((card) =>
                            <CardExec key={card.id} card={card} />
                        )
                        : 'Nenhuma etapa planejada. Clique em Iniciar para gerar as etapas.'
                }
                </Flex>
            </>,
        },
        {
            key: '4',
            label: 'Validações',
            children: <Flex wrap gap="small" justify="center">
                {
                    valid.map((vl, index) =>
                    (<List
                        key={index + 1}
                        header={<b>{vl.name}</b>}
                        footer={null}
                        bordered
                        style={{ width: "100%" }}
                        dataSource={vl.result}
                        renderItem={(item: any) => {
                            if (item.qtd > 0) {
                                return (
                                    <List.Item>
                                        {item.valor} = {item.qtd} jogos ({((item.qtd / item.tot) * 100).toFixed(2) + ' %'})
                                    </List.Item>
                                )
                            }
                        }}
                    />)
                    )}
            </Flex>,
        },
    ];

    return (
        <>
            {planFileAlert && <Alert
                message={planFileAlert.message}
                type={planFileAlert.type}
                showIcon
                closable
                onClose={() => setPlanFileAlert(null)}
                style={{ marginBottom: 10 }}
            />}
            {finish && <Alert
                message="Jogos gerados!"
                type="success"
                showIcon
                closable
                style={{ marginBottom: 10 }}
            />}
            {!running && <>
                <input type="file" ref={inputJSONPlan} onChange={handlePlanFileUpload} style={{ display: 'none' }} />
                <Space>
                    <Button
                        icon={<ImportOutlined />}
                        style={{ minWidth: 130 }}
                        onClick={() => {
                            inputJSONPlan.current.value = null;
                            inputJSONPlan.current.click();
                        }}
                    >
                        Estratégia
                    </Button>
                    <Button
                        icon={<PlayCircleOutlined />}
                        style={{ minWidth: 130 }}
                        onClick={handleStart}
                    >
                        Iniciar
                    </Button>
                </Space>
            </>}
            <Divider />
            <Flex justify="space-between" align="flex-start" style={{ marginBottom: 16 }}>
                <div>
                    <div className="strategy-title-editable">
                        <Typography.Title
                            level={1}
                            style={{ margin: 0 }}
                            editable={
                                running
                                    ? false
                                    : {
                                        onChange: handleTitleChange,
                                        triggerType: ['icon', 'text'],
                                    }
                            }
                        >
                            {title}
                        </Typography.Title>
                    </div>
                    <Flex align="center" gap={8} style={{ marginTop: 12 }}>
                        <span>Modalidade:</span>
                        <Select
                            style={{ width: 240 }}
                            value={modality}
                            disabled={running}
                            onChange={handleModalityChange}
                            options={LOTTERY_MODALITIES.map((item) => ({
                                value: item.value,
                                label: item.label,
                            }))}
                        />
                    </Flex>
                </div>
                <Button
                    icon={<DownloadOutlined />}
                    disabled={running}
                    onClick={handleExportPlan}
                >
                    Exportar estratégia
                </Button>
            </Flex>
            {executionProgressBar}
            <Tabs
                type="card"
                items={[
                    {
                        label: "Execução",
                        key: 1,
                        children: <Collapse items={items} defaultActiveKey={['1', '2', '3', '4']} />,
                    },
                    {
                        label: "Log",
                        key: 2,
                        children: <Flex wrap gap="small" justify="center">
                            <Steps
                                current={current}
                                direction="vertical"
                                //type='dot'
                                items={log}
                            />
                        </Flex>,
                    }
                ]}
            />

            <Modal
                title={
                    <>
                        Configurar lista
                        <Divider style={{ margin: '16px 0 0' }} />
                    </>
                }
                open={listEditModal.open}
                onOk={handleSaveListEdit}
                onCancel={handleCloseListEdit}
                okText="Salvar"
                cancelText="Cancelar"
                destroyOnClose
                footer={[
                    <Button key="delete" danger onClick={handleDeleteListEdit}>
                        Excluir
                    </Button>,
                    <Button key="cancel" onClick={handleCloseListEdit}>
                        Cancelar
                    </Button>,
                    <Button key="save" type="primary" onClick={handleSaveListEdit}>
                        Salvar
                    </Button>,
                ]}
            >
                <Form layout="vertical">
                    <Form.Item
                        label="ID"
                        validateStatus={listEditModal.error ? 'error' : ''}
                        help={listEditModal.error || 'O ID deve ser único entre todas as listas'}
                    >
                        <InputNumber
                            style={{ width: '100%' }}
                            value={listEditModal.editId}
                            onChange={(value) =>
                                setListEditModal((prev) => ({
                                    ...prev,
                                    editId: value,
                                    error: '',
                                }))
                            }
                        />
                    </Form.Item>
                    <Form.Item label="Nome">
                        <Input
                            value={listEditModal.editName}
                            onChange={(e) =>
                                setListEditModal((prev) => ({
                                    ...prev,
                                    editName: e.target.value,
                                    error: '',
                                }))
                            }
                        />
                    </Form.Item>
                    {listEditModal.originalId !== 0 && listEditModal.originalId !== 1 && (
                        <Form.Item
                            label="Excluir após uso"
                            help="Quando ativo, a lista pode ser removida após ser utilizada em uma etapa"
                        >
                            <Switch
                                checked={listEditModal.editExcludeAfterUse}
                                onChange={(checked) =>
                                    setListEditModal((prev) => ({
                                        ...prev,
                                        editExcludeAfterUse: checked,
                                    }))
                                }
                            />
                        </Form.Item>
                    )}
                </Form>
            </Modal>

            <Modal
                title={
                    <>
                        Configurar etapa
                        <Divider style={{ margin: '16px 0 0' }} />
                    </>
                }
                open={nodeEditModal.open}
                width={640}
                onOk={handleSaveNodeEdit}
                onCancel={handleCloseNodeEdit}
                okText="Salvar"
                cancelText="Cancelar"
                destroyOnClose
                footer={[
                    <Button key="delete" danger onClick={handleDeleteNodeEdit}>
                        Excluir
                    </Button>,
                    <Button key="cancel" onClick={handleCloseNodeEdit}>
                        Cancelar
                    </Button>,
                    <Button key="save" type="primary" onClick={handleSaveNodeEdit}>
                        Salvar
                    </Button>,
                ]}
            >
                {nodeEditModal.error ? (
                    <Alert
                        type="error"
                        message={nodeEditModal.error}
                        showIcon
                        style={{ marginBottom: 16 }}
                    />
                ) : null}
                <Tabs
                    type="card"
                    items={[
                        {
                            key: 'tipo',
                            label: 'Tipo',
                            children: (
                                <Form layout="vertical">
                                    <Form.Item
                                        label="ID"
                                        required
                                        validateStatus={
                                            nodeEditModal.error
                                            && !nodeEditModal.fieldErrors?.from
                                            && !nodeEditModal.fieldErrors?.parameters
                                            && !nodeEditModal.fieldErrors?.fromListId
                                            && !nodeEditModal.fieldErrors?.toListId
                                                ? 'error'
                                                : ''
                                        }
                                        help={
                                            nodeEditModal.error
                                            && !nodeEditModal.fieldErrors?.from
                                            && !nodeEditModal.fieldErrors?.parameters
                                            && !nodeEditModal.fieldErrors?.fromListId
                                            && !nodeEditModal.fieldErrors?.toListId
                                                ? nodeEditModal.error
                                                : 'O ID deve ser único entre todas as etapas'
                                        }
                                    >
                                        <InputNumber
                                            style={{ width: '100%' }}
                                            value={nodeEditModal.editId}
                                            onChange={(value) =>
                                                setNodeEditModal((prev) => ({
                                                    ...prev,
                                                    editId: value,
                                                    error: '',
                                                }))
                                            }
                                        />
                                    </Form.Item>
                                    <Form.Item label="Título" required>
                                        <Input
                                            value={nodeEditModal.editTitle}
                                            onChange={(e) =>
                                                setNodeEditModal((prev) => ({
                                                    ...prev,
                                                    editTitle: e.target.value,
                                                    error: '',
                                                }))
                                            }
                                        />
                                    </Form.Item>
                                    <Form.Item label="Tipo" required>
                                        <Select
                                            style={{ width: '100%' }}
                                            value={nodeEditModal.editType}
                                            onChange={handleNodeTypeChange}
                                            options={NODE_TYPE_SELECT_OPTIONS}
                                        />
                                    </Form.Item>
                                    {getNodeTypeOption(nodeEditModal.editType).from && (
                                        <Form.Item
                                            label="Fontes"
                                            required
                                            validateStatus={nodeEditModal.fieldErrors?.from ? 'error' : ''}
                                            help={
                                                nodeEditModal.fieldErrors?.from
                                                || 'Etapas conectadas à entrada desta etapa'
                                            }
                                        >
                                            <Select
                                                mode="multiple"
                                                style={{ width: '100%' }}
                                                placeholder="Selecione as etapas de origem"
                                                value={nodeEditModal.editFrom}
                                                onChange={(value) =>
                                                    setNodeEditModal((prev) => ({
                                                        ...prev,
                                                        editFrom: value,
                                                        error: '',
                                                        fieldErrors: {
                                                            ...prev.fieldErrors,
                                                            from: undefined,
                                                        },
                                                    }))
                                                }
                                                options={nodes
                                                    .filter((node) => node.id !== nodeEditModal.originalId)
                                                    .map((node) => ({
                                                        value: node.id,
                                                        label: `${node.id} - ${node.title}`,
                                                    }))}
                                            />
                                        </Form.Item>
                                    )}
                                </Form>
                            ),
                        },
                        ...(getNodeTypeOption(nodeEditModal.editType).params
                            || getNodeTypeStepLinks(nodeEditModal.editType).usesFromList
                            || getNodeTypeStepLinks(nodeEditModal.editType).usesToList ? [{
                            key: 'parametros',
                            label: 'Parâmetros',
                            children: (
                                <Form layout="vertical">
                                    {getNodeTypeStepLinks(nodeEditModal.editType).usesFromList && (
                                        <Form.Item
                                            label="Lista origem (from)"
                                            required
                                            validateStatus={nodeEditModal.fieldErrors?.fromListId ? 'error' : ''}
                                            help={nodeEditModal.fieldErrors?.fromListId}
                                        >
                                            <Select
                                                style={{ width: '100%' }}
                                                placeholder="Selecione a lista de origem"
                                                value={nodeEditModal.editFromListId}
                                                onChange={(value) =>
                                                    setNodeEditModal((prev) => ({
                                                        ...prev,
                                                        editFromListId: value,
                                                        error: '',
                                                        fieldErrors: {
                                                            ...prev.fieldErrors,
                                                            fromListId: undefined,
                                                        },
                                                    }))
                                                }
                                                options={lists.map((list) => ({
                                                    value: list.id,
                                                    label: `${list.id} - ${list.name}`,
                                                }))}
                                            />
                                        </Form.Item>
                                    )}
                                    {getNodeTypeStepLinks(nodeEditModal.editType).usesToList && (
                                        <Form.Item
                                            label="Lista destino (to)"
                                            required
                                            validateStatus={nodeEditModal.fieldErrors?.toListId ? 'error' : ''}
                                            help={nodeEditModal.fieldErrors?.toListId}
                                        >
                                            <Select
                                                style={{ width: '100%' }}
                                                placeholder="Selecione a lista de destino"
                                                value={nodeEditModal.editToListId}
                                                onChange={(value) =>
                                                    setNodeEditModal((prev) => ({
                                                        ...prev,
                                                        editToListId: value,
                                                        error: '',
                                                        fieldErrors: {
                                                            ...prev.fieldErrors,
                                                            toListId: undefined,
                                                        },
                                                    }))
                                                }
                                                options={lists.map((list) => ({
                                                    value: list.id,
                                                    label: `${list.id} - ${list.name}`,
                                                }))}
                                            />
                                        </Form.Item>
                                    )}
                                    {getNodeTypeParameterDefinitions(nodeEditModal.editType).map((definition) => (
                                        <Form.Item
                                            key={definition.key}
                                            label={definition.label}
                                            required
                                            validateStatus={
                                                nodeEditModal.fieldErrors?.parameters?.[definition.key]
                                                    ? 'error'
                                                    : ''
                                            }
                                            help={nodeEditModal.fieldErrors?.parameters?.[definition.key]}
                                        >
                                            {definition.inputType === 'array' ? (
                                                <Input.TextArea
                                                    value={
                                                        nodeEditModal.editParameterValues[definition.key] !== undefined
                                                            ? JSON.stringify(
                                                                nodeEditModal.editParameterValues[definition.key],
                                                                null,
                                                                2
                                                            )
                                                            : ''
                                                    }
                                                    onChange={(e) =>
                                                        handleParameterValueChange(
                                                            definition.key,
                                                            e.target.value,
                                                            'array'
                                                        )
                                                    }
                                                    autoSize={{ minRows: 3, maxRows: 8 }}
                                                />
                                            ) : (
                                                <InputNumber
                                                    style={{ width: '100%' }}
                                                    value={nodeEditModal.editParameterValues[definition.key] ?? null}
                                                    onChange={(value) =>
                                                        handleParameterValueChange(
                                                            definition.key,
                                                            value,
                                                            'number'
                                                        )
                                                    }
                                                />
                                            )}
                                        </Form.Item>
                                    ))}
                                </Form>
                            ),
                        }] : []),
                        ...(getNodeTypeOption(nodeEditModal.editType).filter ? [{
                            key: 'filtros',
                            label: 'Filtros',
                            children: (
                                <>
                                    <Button
                                        type="primary"
                                        icon={<PlusOutlined />}
                                        onClick={handleOpenAddFilter}
                                        style={{ marginBottom: 12 }}
                                    >
                                        Adicionar
                                    </Button>
                                    <List
                                        bordered
                                        locale={{ emptyText: 'Nenhum filtro cadastrado' }}
                                        dataSource={nodeEditModal.editFilters}
                                        renderItem={(item, index) => (
                                            <List.Item style={{ display: 'block' }}>
                                                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, width: '100%' }}>
                                                    <div style={{ flex: 1, minWidth: 0 }}>
                                                        <div style={{ fontWeight: 600, color: '#262626', wordBreak: 'break-word' }}>
                                                            {getFilterLabel(item.name)}
                                                        </div>
                                                        <div style={{ color: '#8c8c8c', marginTop: 4, wordBreak: 'break-word' }}>
                                                            {formatFilterDescription(item)}
                                                        </div>
                                                    </div>
                                                    <Space size={4} style={{ flexShrink: 0 }}>
                                                        <Button
                                                            type="text"
                                                            size="small"
                                                            icon={<EditOutlined />}
                                                            aria-label="Editar filtro"
                                                            style={LIST_ACTION_BUTTON_STYLE.edit}
                                                            onClick={() => handleOpenEditFilter(index)}
                                                        />
                                                        <Button
                                                            type="text"
                                                            size="small"
                                                            danger
                                                            icon={<DeleteOutlined />}
                                                            aria-label="Excluir filtro"
                                                            style={LIST_ACTION_BUTTON_STYLE.delete}
                                                            onClick={() => handleRemoveNodeFilter(index)}
                                                        />
                                                    </Space>
                                                </div>
                                            </List.Item>
                                        )}
                                    />
                                </>
                            ),
                        }] : []),
                    ]}
                />
            </Modal>

            <Modal
                title={
                    <>
                        {filterItemModal.editIndex === null ? 'Adicionar filtro' : 'Editar filtro'}
                        <Divider style={{ margin: '16px 0 0' }} />
                    </>
                }
                open={filterItemModal.open}
                width={480}
                onOk={handleSaveFilterItem}
                onCancel={handleCloseFilterItemModal}
                okText="Salvar"
                cancelText="Cancelar"
                destroyOnClose
            >
                <Form layout="vertical">
                    <Form.Item
                        label="Filtro"
                        validateStatus={filterItemModal.error && !filterItemModal.name ? 'error' : ''}
                        help={filterItemModal.error && !filterItemModal.name ? filterItemModal.error : 'Selecione o tipo de filtro'}
                    >
                        <Select
                            style={{ width: '100%' }}
                            placeholder="Selecione o filtro"
                            value={filterItemModal.name || undefined}
                            onChange={handleFilterNameChange}
                            options={FILTER_OPTIONS.map((item) => ({
                                value: item.value,
                                label: item.label,
                            }))}
                        />
                    </Form.Item>
                    {getFilterDefinition(filterItemModal.name)?.parameters.map((key) => (
                        <Form.Item
                            key={key}
                            label={FILTER_PARAMETER_LABELS[key] || key}
                        >
                            <InputNumber
                                style={{ width: '100%' }}
                                value={filterItemModal.parameters[key]}
                                onChange={(value) => handleFilterParameterChange(key, value)}
                            />
                        </Form.Item>
                    ))}
                    {filterItemModal.error ? (
                        <div style={{ color: '#ff4d4f' }}>{filterItemModal.error}</div>
                    ) : null}
                </Form>
            </Modal>

        </>
    )
}

const TLSGerarCombinacoes = () => (
    <App>
        <TLSGerarCombinacoesContent />
    </App>
);

export default TLSGerarCombinacoes;